<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.name || userData.username }}
        </p>
        <!-- <span class="user-status">{{ userData.role }}</span> -->
      </div>
      <!-- <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      > -->
      <b-avatar
        size="40"
        :src="getProfilePhotoWithPath()"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.full_name"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profile</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>Inbox</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CheckSquareIcon"
        class="mr-50"
      />
      <span>Task</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MessageSquareIcon"
        class="mr-50"
      />
      <span>Chat</span>
    </b-dropdown-item> -->

    <b-dropdown-divider />

    <b-dropdown-item :to="{ name: 'profile_setting' }" link-class="d-flex align-items-center">
      <feather-icon size="16" icon="SettingsIcon" class="mr-50"/>
      <span>Settings</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item v-for="(studyGroup, index) in studyGroups" :key="index" :to="`/study-group/${studyGroup.id}`" link-class="d-flex align-items-center"> -->
    <b-dropdown-item v-for="(studyGroup, index) in studyGroups" :key="index" :to="{ path: `/site/study-group/${studyGroup.id}`, force: true }" link-class="d-flex align-items-center">
      <!-- <feather-icon size="16" icon="UsersIcon" class="mr-50" /> -->
      <b-avatar variant="success" icon="people-fill" class="mr-50"></b-avatar>
      <span v-html="studyGroup.name"></span>
    </b-dropdown-item>
    <b-dropdown-item :to="`/site/create-study-group`" link-class="d-flex align-items-center">
      <feather-icon size="16" icon="PlusCircleIcon" class="mr-50" />
      <!-- <font-awesome-icon icon="fa-sharp fa-solid fa-people-group" /> -->
      <span>Create a new group</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Pricing</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import store from '@/store'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
import ModalBaseMasterList from '@core/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      loading: false,
      // userData: JSON.parse(localStorage.getItem('userData')),
      // userData: {},
      avatarText,
    }
  },
  created () {
    // this.getAuthData()
  },
  computed: {
    userData () {
      return Object.keys(this.$store.state.authUser).length !== 0 ? this.$store.state.authUser : this.user
    },
    studyGroups: function () {
      return this.$store.state.studyGroups
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('logoutLoading', true)
      await RestApi.getData(studyPressBaseUrl, 'api/logout')
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('activityLogList')
      localStorage.removeItem('categoryList')
      localStorage.removeItem('userData')
      localStorage.removeItem('access_token')
      localStorage.removeItem('token_type')
      localStorage.removeItem('pusherTransportTLS')
      this.vuexStoreDataRemove()

      // Reset ability
      this.$ability.update(initialAbility)
      // store.commit('resetVuexStoreData')

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
      this.$store.dispatch('logoutLoading', false)
    },
    vuexStoreDataRemove () {
      this.$store.dispatch('AuthUser', [])
      this.$store.commit('mutateCommonProperties', {
        hasDropdownLoaded: false
      })
    },
    getProfilePhotoWithPath(){
      let photo = this.userData.details.photo
      console.log('photo', photo)
      if(photo){
          // let pt = studyPressBaseUrl + "public/asset/images/upload/" + 
          let pt = require('@/assets/images/upload/' + photo)
          return pt;
      }else{               
          let pt = require('@/assets/images/upload/boy.jpg')
          return pt;
      }
    },
    getAuthData: async function () {
      
      try {

        this.loading = true
        const result = await RestApi.getData(studyPressBaseUrl, `/api/ajax/get_auth_user`)
        const myObject = {}
        myObject.role = result.data.authUser.role_id === 1 ? 'admin' : 'admin'
        myObject.ability = [{action: "manage", subject: "all"}]
        const userData = Object.assign({}, result.data.authUser, myObject)
        this.$store.dispatch('AuthUser', {userData})
        this.$store.dispatch('studyGroups', result.data.studyGroups)
        this.$store.dispatch('userEnrollment', result.data.userEnrollment)
        this.loading = false

      } catch (error) {
        // this.errMsg(error)
        this.loading = false
      }
    },
  },
}
</script>

<style>
.header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
  width: 250px !important;
}
</style>
